export default __webpack_public_path__ + "static/media/lg-electronics.0b46b98d.svg";